import { graphql, useStaticQuery } from "gatsby";
import React, { useMemo, useState } from "react";
import Slider from "react-slick";
import { Link } from "./link";

const BenefitContent = ({ item }) => {
  return (
    <>
      {item.mainBenefitsIcon?.node && (
        <img
          src={item.mainBenefitsIcon.node.publicURL}
          alt={item.mainBenefitsIcon?.value?.description || ""}
          className="main-benefits__icon d-inline-block mr-3"
          loading="eager"
        />
      )}
      <div className="main-benefits__title">{item.mainBenefitsTitle || ""}</div>
    </>
  );
};

const BenefitSlide = ({ item, dragging }) => {
  return (
    <>
      {item.mainBenefitsLink ? (
        <Link
          to={item.mainBenefitsLink}
          className="main-benefits__slide main-benefits__slide--link"
          onClick={(e) => dragging && e.preventDefault()}
        >
          <BenefitContent item={item} />
        </Link>
      ) : (
        <div className="main-benefits__slide">
          <BenefitContent item={item} />
        </div>
      )}
    </>
  );
};

const MainBenefits = ({ data }) => {
  const { liferayMainBenefits } = useStaticQuery(graphql`
    {
      liferayMainBenefits: allLiferayMainBenefits {
        nodes {
          fieldsGroup {
            benefitsForCustomPage
            mainBenefitsTitle
            mainBenefitsIcon {
              value {
                description
              }
              node {
                publicURL
              }
            }
            mainBenefitsPosition
            mainBenefitsLink
          }
        }
      }
    }
  `);

  const [dragging, setDragging] = useState(false);

  const settings = {
    dots: false,
    infinite: true,
    arrows: false,
    slidesToShow: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: false,
    beforeChange: () => setDragging(true),
    afterChange: () => setDragging(false),
  };

  const mainBenefits = useMemo(() => {
    return data?.length
      ? data?.[0]?.fieldsGroup
        ? data?.[0]?.fieldsGroup.slice(0, 4).sort((a, b) => {
            const posA = isNaN(a?.mainBenefitsPosition) ? 0 : Number(a?.mainBenefitsPosition);
            const posB = isNaN(b?.mainBenefitsPosition) ? 0 : Number(b?.mainBenefitsPosition);
            return posA - posB;
          })
        : null
      : liferayMainBenefits?.nodes?.find((benefit) =>
          benefit?.fieldsGroup?.some((item) => item?.benefitsForCustomPage?.[0] !== "yes")
        )?.fieldsGroup
      ? liferayMainBenefits?.nodes
          ?.find((benefit) =>
            benefit?.fieldsGroup?.some((item) => item?.benefitsForCustomPage?.[0] !== "yes")
          )
          ?.fieldsGroup?.filter((item) => item?.benefitsForCustomPage?.[0] !== "yes")
          .slice(0, 4)
          .sort((a, b) => {
            const posA = isNaN(a?.mainBenefitsPosition) ? 0 : Number(a?.mainBenefitsPosition);
            const posB = isNaN(b?.mainBenefitsPosition) ? 0 : Number(b?.mainBenefitsPosition);
            return posA - posB;
          })
      : null;
  }, [liferayMainBenefits, data]);

  return mainBenefits && mainBenefits?.some((item) => item.mainBenefitsTitle) ? (
    <section className="main-benefits">
      <div className="container-fluid wrapper">
        <div className="row">
          <div className="col-12">
            <Slider
              {...settings}
              className="d-lg-none slider-main-benefits justify-content-around align-items-center mb-0"
            >
              {mainBenefits
                .filter((item) => item.mainBenefitsTitle)
                .map((item, i) => (
                  <BenefitSlide item={item} key={i} dragging={dragging} />
                ))}
            </Slider>
            <div className="d-none d-lg-flex slider-main-benefits justify-content-around align-items-center mb-0">
              {mainBenefits
                .filter((item) => item.mainBenefitsTitle)
                .map((item, i) => (
                  <BenefitSlide item={item} key={i} />
                ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  ) : null;
};

export default MainBenefits;
